import { render, staticRenderFns } from "./ModifyCourse.vue?vue&type=template&id=2b0fe056&"
import script from "./ModifyCourse.vue?vue&type=script&lang=js&"
export * from "./ModifyCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports